module.exports = __webpack_public_path__ + "static/media/Application programming interface-amico.c2fa09ff.svg";